import { API_BASE_URL } from "../config/api";

const API_BASE = API_BASE_URL;

// Get token from sessionStorage (more secure than localStorage)
// In future iterations, will be replaced with HttpOnly cookie + refresh token system
const getToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });
const authJsonHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

export const api = {
  get: (path, { auth = true, signal } = {}) =>
    fetch(`${API_BASE}${path}`, {
      headers: auth ? authHeaders() : {},
      credentials: "include", // Include cookies in requests
      ...(signal ? { signal } : {}),
    }),

  post: (path, body, { multipart = false, auth = true } = {}) =>
    fetch(`${API_BASE}${path}`, {
      method: "POST",
      headers: multipart
        ? auth
          ? authHeaders()
          : {}
        : auth
          ? authJsonHeaders()
          : { "Content-Type": "application/json" },
      credentials: "include", // Include cookies in requests
      body: multipart ? body : JSON.stringify(body),
    }),

  patch: (path, body) =>
    fetch(`${API_BASE}${path}`, {
      method: "PATCH",
      headers: body !== undefined ? authJsonHeaders() : authHeaders(),
      credentials: "include", // Include cookies in requests
      body: body !== undefined ? JSON.stringify(body) : undefined,
    }),

  patchQuery: (path) =>
    fetch(`${API_BASE}${path}`, {
      method: "PATCH",
      headers: authHeaders(),
      credentials: "include", // Include cookies in requests
    }),

  put: (path, body) =>
    fetch(`${API_BASE}${path}`, {
      method: "PUT",
      headers: authJsonHeaders(),
      credentials: "include", // Include cookies in requests
      body: JSON.stringify(body),
    }),

  delete: (path) =>
    fetch(`${API_BASE}${path}`, {
      method: "DELETE",
      headers: authHeaders(),
    }),
};

export const extractApiErrorMessage = (
  payload,
  fallback = "Ocurrió un error inesperado",
) => {
  if (!payload) return fallback;

  const detail = payload.detail ?? payload.message;
  if (!detail) return fallback;

  if (typeof detail === "string") return detail;

  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    if (typeof first === "string") return first;
    if (first?.msg) return first.msg;
    if (first?.message) return first.message;
    return fallback;
  }

  if (typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    if (typeof detail.message === "string") return detail.message;
  }

  return fallback;
};
